
import React, { useState } from 'react';
import { Search, Plus, Filter } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import FilterButton from './ui/FilterButton';
import ComingSoonModal from './ComingSoonModal';
import { FEATURE_FLAGS } from '@/config/featureFlag';

interface MobileMenuProps {
  onAddNewPortfolio: () => void;
  onSearch: (searchTerm: string) => void;
  currentSearchTerm?: string;
  setShowMobileSearch?: (show: boolean) => void;
  showMobileSearch?: boolean;
  setShowFilterButton?: (show: boolean) => void;
  showFilterButton?: boolean;
  toggleFilterButton?: () => void;
  showFilterOptions?: boolean;
  hasActiveFilters?: boolean;
  onShowMobileAddBusinessModal?: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ 
  onAddNewPortfolio, 
  onSearch, 
  currentSearchTerm = "",
  setShowMobileSearch,
  showMobileSearch = false,
  toggleFilterButton,
  showFilterButton = false,
  showFilterOptions = false,
  hasActiveFilters = false,
  setShowFilterButton,
  onShowMobileAddBusinessModal
}) => {
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  // Toggle mobile search display
  const toggleSearch = () => {
    if (setShowMobileSearch) {
      setShowMobileSearch(!showMobileSearch);
    }
  };

  // Handle toggling the filter button visibility
  const handleToggleFilterButton = () => {
    if (setShowFilterButton) {
      setShowFilterButton(!showFilterButton);
    }
  };

  return (
    <div className="flex items-center justify-end gap-2">
      {/* Filter button - displayed conditionally based on showFilterButton state */}
      {showFilterButton && (
        <Button 
          variant="outline" 
          size="sm" 
          className="gap-2 border border-gray-200 bg-white hover:bg-gray-50 rounded-md"
          onClick={toggleFilterButton}
        >
          <Filter size={16} className="text-gray-600" />
          Filter
        </Button>
      )}
      
      {FEATURE_FLAGS.PORTFOLIO_FILTERS && (
        <>
          <FilterButton 
            isActive={showFilterOptions}
            hasFilters={hasActiveFilters}
            onClick={toggleFilterButton}
          />
          
          <Button 
            variant="ghost" 
            size="icon" 
            className="h-8 w-8 rounded-full"
            onClick={toggleSearch}
          >
            <Search size={20} className="text-gray-600" />
          </Button>
        </>
      )}
      
      {/* Add business button */}
      <Button 
        variant="ghost" 
        size="icon" 
        className="h-8 w-8 rounded-full"
        onClick={() => setShowComingSoonModal(true)}
      >
        <Plus size={20} className="text-gray-600" />
      </Button>
      <ComingSoonModal
        open={showComingSoonModal}
        onOpenChange={setShowComingSoonModal}
        description='To Create Business or Portfolio please contact us.' 
      />
    </div>
  );
};

export default MobileMenu;
